import {TableConfig} from '@shared/interfaces/table/table-config';
import {MeterSearchAvailableDto} from '@app/api/nts';

export const meterSimpleTableConfig: TableConfig<MeterSearchAvailableDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'meter.meterNumber',
      key: 'meterNumber'
    },
    {
      title: 'meter.alternativeMeterNumber',
      key: 'alternativeMeterNumber'
    },
    {
      title: 'meter.serialNumber',
      key: 'serialNumber',
    },
  ]
};
